export default "__VITE_ASSET__DyXYP4eV__"